import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { SITE_NAME, SITE_URL, OG_IMAGE } from "@/lib/seo";

// index.html ships static SEO tags so non-JS crawlers and social scrapers see
// something. Once React mounts, Helmet owns them, so the static copies are
// removed to avoid duplicate description/canonical tags.
function useStripStaticSeoTags() {
  useEffect(() => {
    document
      .querySelectorAll("head [data-static-seo]")
      .forEach((el) => el.parentNode.removeChild(el));
  }, []);
}

export default function Seo({
  title,
  description,
  path = "/",
  image = OG_IMAGE,
  type = "website",
  keywords,
  noindex = false,
  schema,
}) {
  useStripStaticSeoTags();
  const url = `${SITE_URL}${path}`;
  return (
    <Helmet prioritizeSeoTags>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:image:alt" content={title} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {schema && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
    </Helmet>
  );
}
